import clsx from 'clsx';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface SimpleCardProps {
  children: ReactNode;
  className?: string;
}

const SimpleCard: React.FC<SimpleCardProps> = ({ children, className }) => (
  <div className={twMerge(clsx('border-primary-200 rounded-2xl border-2 bg-white', className))}>{children}</div>
);

export default SimpleCard;
